// extracted by mini-css-extract-plugin
module.exports = {"nav-dropdown":"Header_nav-dropdown__2q_cH","nav-dropdown-content":"Header_nav-dropdown-content__1Y8c4","nav_link":"Header_nav_link__2PslH"};